import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'receipt_wage_payment_confirmed_writing_workers'

export const dataPointDefinition = {
  retracedId: 'receipt_wage_payment_confirmed_writing_workers',
  name: 'Is the receipt of wage payment confirmed in writing by workers?',
  description:
    'The intent of this question is to understand if there is some kind of written evidence that proves that workers received wage payments (i.e. worker signature).',
  meta: {
    slcpMeta: {
      key: 'wb-16--4',
      number: 'WB-WAGE-111',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-16--4', version: '1.7.0', provider: 'slcp'}],
  sortingId: 35080,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
